import TransactionListModal from '@/components/transactions/TransactionListModal'
import { ENTITY_TYPES } from '@/data/constants/constants'
import { CellContext } from '@tanstack/react-table'
import React, { useRef, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

export default function ClickableCell({
  cellContext: info,
  col,
}: {
  cellContext: CellContext<any, any>
  col: any
}) {
  const { categoryId, vaultId } = useParams()
  const [searchParams] = useSearchParams()
  const transactionType = searchParams.get('type')
  const selectedOffset = searchParams.get('offset')

  const navigate = useNavigate()
  const clickTimeout = useRef(null)

  const [open, setOpen] = useState(false)

  const handleSingleClick = () => {
    const base =
      info.row.original.entity_type === ENTITY_TYPES.VAULT
        ? 'vaults'
        : 'categories'
    navigate(
      `/${base}/${info.row.original.id}/transactions/new?offset=${col.offset}&type=${info.row.original.entity_type === 'vault' ? 'transfer' : info.row.original.direction === 1 ? 'in' : 'out'}`,
    )
  }

  const handleDoubleClick = () => {
    const base =
      info.row.original.entity_type === ENTITY_TYPES.VAULT
        ? '/transaction-list/vaults'
        : '/transaction-list/categories'

    const navv = `${base}/${info.row.original.id}/transactions?offset=${col.offset}&type=${info.row.original.entity_type === 'vault' ? 'transfer' : info.row.original.direction === 1 ? 'in' : 'out'}`
    navigate(navv, {
      replace: true,
    })
    // navigate('/')

    // setOpen(true)

    // const base =
    //   info.row.original.entity_type === ENTITY_TYPES.VAULT
    //     ? 'vaults'
    //     : 'categories'
    // navigate(
    //   `/${base}/${info.row.original.id}/transaction-list/new?offset=${col.offset}&type=${info.row.original.entity_type === 'vault' ? 'transfer' : info.row.original.direction === 1 ? 'in' : 'out'}`,
    // )
  }

  const handleClick = () => {
    // Clear any existing timeout to prevent duplicate triggers
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current)
      clickTimeout.current = null
    }

    // Start a new timeout for single click
    clickTimeout.current = setTimeout(() => {
      handleSingleClick()
      clickTimeout.current = null
    }, 250)
  }

  const handleDoubleClickWrapper = () => {
    // Cancel pending single click
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current)
      clickTimeout.current = null
    }
    handleDoubleClick()
  }
  return (
    <>
      {/* <TransactionListModal open={open} setOpen={setOpen} /> */}
      <div
        role="button"
        onClick={handleClick}
        onDoubleClick={handleDoubleClickWrapper}
        data-active={
          // info.cell.id === currentCell?.id ? true : undefined
          selectedOffset == col.offset &&
          (transactionType === 'transfer'
            ? info.row.original.entity_type === ENTITY_TYPES.VAULT &&
              info.row.original.id == vaultId
            : info.row.original.entity_type ===
                ENTITY_TYPES.TRANSACTION_CATEGORY &&
              info.row.original.id == categoryId)
            ? true
            : undefined
        }
        className="absolute inset-0 cursor-pointer transition-all hover:bg-gray-tr-08 data-[active]:border data-[active]:border-accent data-[active]:bg-accent-tr-08"
      ></div>
    </>
  )
}
